import { render, staticRenderFns } from "./socialSecurityPolicy.vue?vue&type=template&id=52d69715&scoped=true&"
import script from "./socialSecurityPolicy.vue?vue&type=script&lang=js&"
export * from "./socialSecurityPolicy.vue?vue&type=script&lang=js&"
import style0 from "./socialSecurityPolicy.vue?vue&type=style&index=0&id=52d69715&prod&scoped=true&lang=css&"
import style1 from "./socialSecurityPolicy.vue?vue&type=style&index=1&id=52d69715&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d69715",
  null
  
)

export default component.exports